import {
  Col,
  Popover,
  Space,
  TableColumnType,
} from 'antd'
import moment from 'moment'
import React from 'react'
import { BillingCategoryName } from '../../models/billingCategory'
import './notshow.css'
import styles from './InventoryInit.module.css'
import { Dimen } from '../../models/dimen'
import { getChrgitmLvName } from '../../models/commodity'
import { Checks } from '../../models/setting'

// 新老目录展示方式 (老目录没有区分药品类别/无型号)
export const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory
  const packSpec = item.packSpec ? item.packSpec : '-'
  const spec = item.spec ? item.spec : '-'
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
  const model = item.model ? '/' + item.model : ''

  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == '0') {
      // 生产厂家  + 包装规格  + 剂型
      return tenantSupplierName + '/' + packSpec + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 生产厂家 + 包装规格 + 型号 
      return tenantSupplierName + '/' + packSpec + model
    } else {
      // 生产厂家  + 包装规格 
      return tenantSupplierName + '/' + packSpec
    }
  } else {
    if (materialsCategory == '0') {
      // 生产厂家 + 规格 + 包装规格  + 剂型
      return tenantSupplierName + '/' + spec + '/' + packSpec + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 生产厂家 + 规格 + 型号 
      return tenantSupplierName + '/' + spec + model
    } else {
      // 生产厂家 + 规格
      return tenantSupplierName + '/' + spec 
    }
  }
}

// 医保初始化列
export const Columns = (
  flag: number,
  startIndex: number,
  settings: any
): TableColumnType<any>[] => {

  return [
    {
      title: '序号',
      dataIndex: '',
      width: Dimen.Num,
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '商品信息',
      fixed: 'left',
      render: function Element(_, record) {
        const deadline = moment(record.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        const inventoryAlert = record.inventoryAlert && record.inventoryAlert > 0 && record.count < record.inventoryAlert
        const inventoryAlertText = inventoryAlert ? '（库存不足' + record.inventoryAlert + record.accountUnit + '）' : ''
        const errorTips = record.name + ' 在库存小于 ' +record.inventoryAlert + record.accountUnit +  ' 时预警'
        const color = days > 180 ||days > 90 ||  days > 30 || days > 0 || record.mergeFlag? '#333333' : '#999999'
        if (record.name == '') {
          return ''
        } else {
          return {
            props: {
              style: {
                maxWidth: 500,
                overflow: 'hidden',
              },
            },
            children: (
              <Space
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Col>
                  <Popover
                    content={
                      <>
                        <div
                          style={{
                            height: '55px',
                            color:inventoryAlert ? 'red' :''
                          }}
                        >
                          <p
                            title={errorTips}
                            className={styles.nameText}
                            style={{
                              color: color,
                            }}
                          >
                              <span style={{ color: inventoryAlert ? 'red' : '' }}>
                                {record.name}
                              </span>

                            {inventoryAlert ? (
                              <span style={{ color: 'red' }}>
                                {inventoryAlertText}
                              </span>
                            ) : (
                              ''
                            )}
                          </p>
                          <p
                            className={styles.productText}
                          >
                            {getProcuctInfo(record,settings)}
                          </p>
                        </div>
                      </>
                    }
                    placement='bottom'
                  >
                    <div
                      style={{
                        height: '55px',
                        color:inventoryAlert ? 'red' :''
                      }}
                    >
                      <p
                        title={errorTips}
                        className={styles.nameText}
                        style={{
                          color:color
                        }}
                      >
                        <span style={{ color: inventoryAlert ? 'red' : '' }}>{record.name}</span>
                       

                        {inventoryAlert ? (
                          <span style={{ color: 'red' }}>
                            {inventoryAlertText}
                          </span>
                        ) : (
                          ''
                        )}
                      </p>
                      <p
                        className={styles.productText}
                      >
                        {getProcuctInfo(record,settings)}
                      </p>
                    </div>
                  </Popover>
                </Col>
              </Space>
            ),
          }
        }
      },
      // 商品名/厂家/规格/剂型）name/tenantSupplierName/packSpec/doseCategory
    },
    {
      title: '初始化状态',
      dataIndex: 'approvalNumber',
      width: Dimen.BillingCategory,
      align: 'center',
      render: function Element(_, t) {
        if(t.initFlag == 1){
          return "已初始化";
        }else{
          return "未初始化";
        }
      },
    },
    {
      title: '批次号',
      dataIndex: 'batchNo',
      width: Dimen.BatchNo,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.mergeFlag ? '-' : t.batchNo}
          </div>
        )
      },
    },
    {
      title: '生产日期',
      dataIndex: 'productDate',
      width: Dimen.Time,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        if (t.deadline != '') {
          return t.mergeFlag ? (
            '-'
          ) : (
            <div
              style={{
                color:
                  days > 180 ||
                  days > 90 ||
                  days > 30 ||
                  days > 0 ||
                  t.mergeFlag
                    ? '#333333'
                    : '#999999',
              }}
            >
              {moment(t.productDate).format('YYYY-MM-DD')}
            </div>
          )
        } else {
          return ''
        }
      },
    },
    {
      title: '有效期至',
      dataIndex: 'deadline',
      width: Dimen.Time,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        if (t.deadline != '') {
          return t.mergeFlag ? (
            '-'
          ) : (
            <div
              style={{
                color:
                  days > 180
                    ? '#000000'
                    : days > 90
                    ? '#027AFF'
                    : days > 30
                    ? '#F5BB4A'
                    : days > 0
                    ? '#FF5D5D'
                    : '#999999',
              }}
            >
              {moment(t.deadline).format('YYYY-MM-DD')}
            </div>
          )
        } else {
          return ''
        }
      },
    },
    {
      title: '库存数量',
      dataIndex: 'count',
      width: Dimen.Count,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        if (t.count != '') {
          return (
            <div
              style={{
                color:
                  days > 180 ||
                  days > 90 ||
                  days > 30 ||
                  days > 0 ||
                  t.mergeFlag
                    ? '#333333'
                    : '#999999',
              }}
            >
              {t.count + t.accountUnit}
            </div>
          )
        } else {
          return ''
        }
      },
    },
    {
      title: '拆零数量',
      dataIndex: 'splitCount',
      width: Dimen.Count,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.splitTag ? t.splitCount + t.splitUnit : '-'}
          </div>
        )
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: Dimen.Count,
      align: 'right',
      className: flag ? 'notshow' : '',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        if (t.mergeFlag) {
          return '-'
        } else if (t.unitPrice > 0) {
          return (
            <div
              style={{
                color:
                  days > 180 ||
                  days > 90 ||
                  days > 30 ||
                  days > 0 ||
                  t.mergeFlag
                    ? '#333333'
                    : '#999999',
              }}
            >
              {parseFloat(t.unitPrice).toFixed(5)}
            </div>
          )
        } else {
          return '-'
        }
      },
    },
    {
      title: '售价',
      dataIndex: 'retailPrice',
      width: Dimen.Price,
      align: 'right',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.mergeFlag ? '-' : parseFloat(t.retailPrice).toFixed(5)}
          </div>
        )
      },
    },
    {
      title: '甲乙分类',
      dataIndex: 'chrgitmLvs',
      width: Dimen.Price,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.chrgitmLv ? getChrgitmLvName(t.chrgitmLv) : '-'}
          </div>
        )
      },
    },
    {
      title: '医保国码',
      dataIndex: 'hilistCode',
      width: Dimen.BillingCategory,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.hilistCode}
          </div>
        )
      },
    },
    {
      title: '供应商',
      dataIndex: 'gysName',
      width: Dimen.BillingCategory,
      align: 'center',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color:
                days > 180 || days > 90 || days > 30 || days > 0 || t.mergeFlag
                  ? '#333333'
                  : '#999999',
            }}
          >
            {t.mergeFlag ? '-' : t.gysName}
          </div>
        )
      },
    },
  ]
}

export const DoctorColumns = (
  flag: number,
  startIndex: number,
  settings: any
): TableColumnType<any>[] => {

  return [
    {
      title: '序号',
      dataIndex: '',
      width: Dimen.Num,
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '商品信息',
      // fixed: "left",
      render: function Element(_, record) {
        const inventoryAlert = record.inventoryAlert && record.inventoryAlert > 0 && record.count < record.inventoryAlert
        const errorTips = record.name + ' 在库存小于 ' + record.inventoryAlert + record.accountUnit +  ' 时预警'
        return (
          <div
            style={{
              height: '55px',
              color:inventoryAlert ? 'red' :''
             }}
          >
            <p
              title={errorTips}
              className={styles.nameText}
            >
              {record.name}
              {inventoryAlert? ' （不足' + record.inventoryAlert + record.accountUnit + '）' : ''}
            </p>
            <p className={styles.productInfo}>
              {getProcuctInfo(record,settings)}
            </p>
          </div>
        )
      },
    },
    {
      title: '开票项目',
      dataIndex: 'billingCategory',
      width: Dimen.BillingCategory,
      align: 'center',
      render: (billingCategory: any) => {
        return BillingCategoryName(billingCategory)
      },
    },
    {
      title: '批次号',
      dataIndex: 'batchNo',
      width: Dimen.BatchNo,
      align: 'center',
      render: function Element(_, t) {
        return t.mergeFlag ? '-' : t.batchNo
      },
    },
    {
      title: '有效期至',
      dataIndex: 'deadline',
      width: Dimen.Time,
      align: 'center',
      render: function Element(_, t) {
        return t.mergeFlag ? '-' : moment(t.deadline).format('YYYY-MM-DD')
      },
    },
    {
      title: '拆零比例',
      dataIndex: 'splitScale',
      width: Dimen.SplitScale,
      align: 'center',
      render: function Element(_, t) {
        return t.splitTag ? t.splitScale : '-'
      },
    },
    {
      title: '库存数量',
      dataIndex: 'count',
      width: Dimen.Count,
      align: 'center',
      render: function Element(_, t) {
        return t.count + t.accountUnit
      },
    },
    {
      title: '库存数量（拆零）',
      dataIndex: 'splitCount',
      width: Dimen.Count,
      align: 'center',
      render: function Element(_, t) {
        return t.splitTag ? t.splitCount + t.splitUnit : '-'
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: Dimen.Count,
      align: 'right',
      className: flag ? 'notshow' : '',
      render: function Element(_, t) {
        return t.mergeFlag
          ? '-'
          : t.unitPrice > 0
          ? t.unitPrice
          : // ? parseFloat(t.unitPrice).toFixed(5)
            0
      },
    },
    {
      title: '售价',
      dataIndex: 'retailPrice',
      width: Dimen.Price,
      align: 'right',
      render: function Element(_, t) {
        return t.mergeFlag ? '-' : parseFloat(t.retailPrice).toFixed(5)
      },
    },
  ]
}
